"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlankPageDivider = exports.BlankPageText = exports.BlankPageButtonBar = exports.BlankPageImageSection = exports.BlankPageSection = exports.BlankPageLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("./BlankPageLayout.css");
var FormPageLayout_1 = require("../../components/FormPageLayout");
var Row_1 = require("../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var Stack_1 = require("../../components/Stack");
var Text_1 = require("../../components/Text");
var MDIcon_1 = require("../../components/MDIcon");
var Button_1 = require("../../components/Button");
var R = __importStar(require("../../utils/ramda"));
var Grid_1 = require("../../components/Grid");
(0, MDIcon_1.preloadIcons)("help-circle-outline");
var BlankPageLayout = function (_a) {
  var className = _a.className,
    children = _a.children,
    heading = _a.heading,
    illustration = _a.illustration,
    supportCenterInfo = _a.supportCenterInfo,
    restProps = __rest(_a, ["className", "children", "heading", "illustration", "supportCenterInfo"]);
  var cn = (0, classnames_1.default)("vsx-blank-page-layout", className);
  return (0, jsx_runtime_1.jsxs)(FormPageLayout_1.FormPageLayout, __assign({
    className: cn,
    width: "medium",
    gap: true
  }, restProps, {
    children: [(0, jsx_runtime_1.jsx)(FormPageLayout_1.FormPageBlock, __assign({
      padding: "none"
    }, {
      children: (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
        spacing: "xl"
      }, {
        children: [(0, jsx_runtime_1.jsx)(Row_1.Row, __assign({
          justify: "center",
          className: "vsx-blank-page-layout-illustration"
        }, {
          children: illustration
        })), (0, jsx_runtime_1.jsx)("div", __assign({
          className: "vsx-blank-page-layout-heading"
        }, {
          children: heading
        })), children]
      }))
    })), supportCenterInfo && (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      justify: "center",
      gap: "medium",
      align: "center"
    }, {
      children: [(0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
        icon: "help-circle-outline",
        color: "var(--color-icon-default)",
        size: "1.5em"
      }), (0, jsx_runtime_1.jsx)("span", {
        children: supportCenterInfo
      })]
    }))]
  }));
};
exports.BlankPageLayout = BlankPageLayout;
var BlankPageSection = function (_a) {
  var className = _a.className,
    heading = _a.heading,
    children = _a.children,
    expanded = _a.expanded,
    description = _a.description,
    headingImage = _a.headingImage,
    restProps = __rest(_a, ["className", "heading", "children", "expanded", "description", "headingImage"]);
  var _b = __read((0, react_1.useState)(expanded !== null && expanded !== void 0 ? expanded : true), 2),
    isExpanded = _b[0],
    setIsExpanded = _b[1];
  var isExpandable = expanded !== undefined;
  var twoColumns = isExpandable || headingImage;
  var header = (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    gap: "small"
  }, {
    children: [(0, jsx_runtime_1.jsx)("header", __assign({
      className: "vsx-blank-page-layout-section-heading"
    }, {
      children: heading
    })), description && (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({
      size: 13
    }, {
      children: description
    }))]
  }));
  var child = (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-blank-page-layout-section-children"
  }, {
    children: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({
      color: "primary",
      size: 13
    }, {
      children: children
    }))
  }));
  var content = (0, jsx_runtime_1.jsxs)(Grid_1.Grid, __assign({
    columns: twoColumns ? "auto 1fr" : "1fr",
    gap: "large",
    align: "center"
  }, {
    children: [isExpandable ? (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      gap: "large",
      align: "center"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Button_1.IconButton, {
        icon: isExpanded ? "chevron-down" : "chevron-right",
        onClick: function () {
          return setIsExpanded(R.not);
        }
      }), headingImage]
    })) : headingImage, header, isExpanded && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [twoColumns && (0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
        component: "section",
        gap: "large",
        className: (0, classnames_1.default)("vsx-blank-page-layout-section", className)
      }, restProps, {
        children: child
      }))]
    })]
  }));
  return content;
};
exports.BlankPageSection = BlankPageSection;
var BlankPageImageSection = function (_a) {
  var className = _a.className,
    heading = _a.heading,
    illustration = _a.illustration,
    children = _a.children,
    restProps = __rest(_a, ["className", "heading", "illustration", "children"]);
  var header = (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-blank-page-layout-image-section-info-heading"
  }, {
    children: heading
  }));
  var child = (0, jsx_runtime_1.jsx)("div", __assign({
    className: "vsx-blank-page-layout-image-section-info-children"
  }, {
    children: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({
      color: "primary",
      size: 13
    }, {
      children: children
    }))
  }));
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    gap: "large",
    className: (0, classnames_1.default)("vsx-blank-page-layout-image-section", className)
  }, restProps, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-blank-page-layout-image-section-illustration"
    }, {
      children: illustration
    })), (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
      gap: "none",
      className: "vsx-blank-page-layout-image-section-info"
    }, {
      children: [header, child]
    }))]
  }));
};
exports.BlankPageImageSection = BlankPageImageSection;
var BlankPageButtonBar = function (props) {
  return (0, jsx_runtime_1.jsx)(Row_1.Row, __assign({
    justify: "center",
    gap: "medium"
  }, props));
};
exports.BlankPageButtonBar = BlankPageButtonBar;
var BlankPageText = function (props) {
  return (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({
    color: "subdued",
    size: 13
  }, props));
};
exports.BlankPageText = BlankPageText;
var BlankPageDivider = function () {
  return (0, jsx_runtime_1.jsx)("div", {
    role: "separator",
    className: "vsx-blank-page-layout-divider"
  });
};
exports.BlankPageDivider = BlankPageDivider;